<template>
    <div class="w-full absolute  z-20 ">
        <nav
            class="navigation-bar w-full max-w-screen-lg mx-auto m-auto flex flex-col lg:flex-row items-center  bg-blue lg:bg-transparent px-6 lg:px-3 py-3"
        >
            <div class="flex items-center w-full lg:w-auto">
                <hamburger
                    class="mr-6 block lg:hidden"
                    :open="showItemsOnMobile"
                    @click="showItemsOnMobile = !showItemsOnMobile"
                    alt="Menu"
                    aria-label="Menu"
                >
                </hamburger>

                <div class="flex justify-center flex-grow mr-10">
                    <router-link :to="{ name: 'home' }">
                        <app-image
                            url="logo.png"
                            is-local
                            alt="Pinguinitos logo"
                            class="max-w-none"
                            width="165"
                            height="60"
                        >
                        </app-image>
                    </router-link>
                </div>
            </div>

            <div
                class="lg:flex flex-col lg:flex-row justify-end flex-grow items-center"
                :class="{ hidden: !showItemsOnMobile }"
            >
                <div
                    v-for="(item, index) in items"
                    :key="index"
                    :class="navItemLayoutClass"
                >
                    <router-link
                        v-if="item.icon"
                        :to="item.route"
                        class="w-20 lg:mr-4"
                    >
                        <app-image
                            :url="item.icon"
                            :is-local="true"
                            :alt="`Ícono ${item.title}`"
                        >
                        </app-image>
                    </router-link>

                    <router-link :to="item.route" :class="navItemTextClass">
                        {{ item.title }}
                    </router-link>
                </div>

                <div v-if="!authenticatedUser" :class="navItemLayoutClass">
                    <router-link
                        :to="{ name: 'login' }"
                        class="login-icon w-20 z-10"
                    >
                        <app-image
                            url="botonPinguino.png"
                            :is-local="true"
                            alt="Ícono login pinguino"
                        >
                        </app-image>
                    </router-link>

                    <brush-stroke-bg>
                        <router-link
                            :to="{ name: 'login' }"
                            :class="navItemTextClass"
                        >
                            {{ $config("LOGIN") }}
                        </router-link>
                    </brush-stroke-bg>
                </div>

                <div :class="navItemLayoutClass">
                    <button
                        :class="[
                            navItemTextClass,
                            { 'cursor-not-allowed': toggleLangButtonDisabled }
                        ]"
                        @click="toggleLang"
                        :disabled="toggleLangButtonDisabled"
                    >
                        {{ $config("TOGGLE_LANG") }}
                    </button>
                </div>

                <template v-if="authenticatedUser">
                    <div :class="navItemLayoutClass">
                        <router-link
                            :to="{ name: 'preferences' }"
                            :class="navItemTextClass"
                            :title="$config('PREFERENCIAS')"
                        >
                            <font-awesome-icon icon="cog" />
                        </router-link>
                    </div>

                    <div :class="navItemLayoutClass">
                        <button
                            :class="navItemTextClass"
                            @click="signOut"
                            :title="$config('LOGOUT')"
                        >
                            <font-awesome-icon icon="sign-out-alt" />
                        </button>
                    </div>
                </template>
            </div>
        </nav>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Hamburger from "./Hamburger";
import BrushStrokeBg from "./BrushStrokeBg";

export default {
    name: "navigation",

    components: { Hamburger, BrushStrokeBg },

    data() {
        return {
            showItemsOnMobile: false,
            toggleLangButtonDisabled: false
        };
    },

    computed: {
        ...mapState(["authenticatedUser"]),

        items() {
            return [
                {
                    title: this.$config("ABOUT"),
                    route: { name: "about" },
                    icon: null,
                    width: "",
                    height: ""
                },
                {
                    title: this.$config("JUEGOS"),
                    route: { name: "games" },
                    icon: "juegos_btn.png",
                    width: "60",
                    height: "60"
                },
                {
                    title: this.$config("SERIE"),
                    route: { name: "series" },
                    icon: "series_btn.png",
                    width: "60",
                    height: "60"
                }
            ];
        },

        navItemLayoutClass() {
            return "flex flex-col lg:flex-row items-center text-center my-3 lg:my-0 lg:mr-5 xl:mr-6";
        },

        navItemTextClass() {
            return "font-primary text-white text-2xl lg:text-xl xl:text-2xl whitespace-no-wrap";
        }
    },

    methods: {
        async toggleLang() {
            this.toggleLangButtonDisabled = true;

            await this.$store.dispatch("TOGGLE_LANG");

            this.toggleLangButtonDisabled = false;
        },

        async signOut() {
            this.$store.dispatch("SIGN_OUT");

            await this.$router.push({ name: "home" }, () => {});
            await this.$router.go();
        }
    },

    watch: {
        $route() {
            this.showItemsOnMobile = false;
        }
    }
};
</script>

<style scoped>
.navigation-bar {
    min-height: 80px;
}

@media (min-width: 1024px) {
    .login-icon {
        margin-right: -30px;
    }
}
</style>
